// http://www.highcharts.com/blog/214-histogram-when-why-how-part2
import _ from 'lodash';

import { getMinGTMultiple } from '../charts/portfolio/analysis/utils/integerUtility';

// 分布図用のデータ作成関数
const getTestScoreHistogramData = (data) => {
  // データポイント数
  const size = data.length;

  if (!size) {
    return [];
  }

  // 何分割するか
  const bins = size < 100 ? 10 : 20;

  // 分布の最大値
  const max = (() => {
    const dataMax = _.max(data);
    if (dataMax <= 100) {
      return 100;
    }
    // dataMax以上で、最小の100の倍数を得る
    return getMinGTMultiple(dataMax, 100);
  })();

  // 分布の最小値(0点未満は考えない)
  const min = 0;
  // トータルの幅
  const range = max - min;
  // 1つ1つの幅
  const width = range / bins;

  const binData = [];
  for (let i = 0; i < bins; i++) {
    const bottom = min + (i * width);
    const top = bottom + width;
    const middle = (bottom + top) / 2;

    const count =
      _.filter(data, (num) => {
        if (top === max) {
          // 最大値は一番上の分布に含む
          return bottom <= num;
        }
        return (bottom <= num) && (num < top);
      }).length;

    binData.push({
      bottom,
      top,
      middle,
      count,
    });
  }

  return {
    binData,
    min,
    max,
    width,
  };
};

export default getTestScoreHistogramData;



// WEBPACK FOOTER //
// ./es6/admin-common-js/apps/csv_chart/utils/getTestScoreHistogramData.js